import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Row, Button } from 'react-bootstrap';
const filter = require('lodash/filter');
const isArray = require('lodash/isArray')
const map = require('lodash/map');
import styled from '@emotion/styled';
const uuid = require('uuid');

const Globals = require('../../../app/globals');
const ActivityActions = require('../actions/ActivityActions');
const ActivityStore = require('../stores/activity_store_reflux');
const TemplateStore = require('../stores/template_store_reflux');
const TemplatePermissionStore = require('../stores/TemplatePermissionStore');
const TemplatePermissionActions = require('../actions/TemplatePermissionActions');
const ProjectStore = require('../stores/ProjectStore');
import Navigator from '../Navigator';
import MainNav from './DashboardNew/Menu/MainNav';
import SubNav from './nav/SubNav';
import BackButton from './nav/BackButton';
import SingleInputModal from './modal/SingleInputModal2';
import ErrorBox from './common/ErrorBox';
import LoadingMainContent from './loading/LoadingMainContent';

let ActivityTypeDiv = styled.div`
    display: block;
    input {
        display: inline-block;
    }
    label {
        display: inline-block;
    }
`;

function isXsScreen(screenWidth) {
    return screenWidth <= 575;
}

// Template name used for css classes / ids
function getTemplateClassName(template) {
    return template.name.toLowerCase().replace(/ /g, '-'); //replace all occurrences of space char
}

const propTypes = {
    history: PropTypes.object.isRequired,
    channelId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
};

const defaultProps = {};

class CreateActivityView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            templateStoreState: TemplateStore.getState(),
            templatePermissionStoreState: TemplatePermissionStore.getState(),
            projectStoreState: ProjectStore.getStateProject(props.projectId),
            activityStoreState: ActivityStore.getStateProject(props.projectId, props.channelId),
            hasError: false,
            errorMessage: '',
            selectedTemplate: null,
            pageWidth: window.innerWidth,
            createActivityActionId: null,
            createActivityModalState: false,
        };

        this.onWindowResize = this.onWindowResize.bind(this);
        this.createActivity = this.createActivity.bind(this);
        this.selectTemplate = this.selectTemplate.bind(this);
        this.backHandler = this.backHandler.bind(this);
        this.setCreateActivityModalState = this.setCreateActivityModalState.bind(this);
        this.unsubscribes = [
            TemplateStore.listen(this.onTemplateStoreChange.bind(this)),
            ProjectStore.listen(this.onProjectStoreChange.bind(this)),
            ActivityStore.listen(this.onActivityStoreChange.bind(this)),
            TemplatePermissionStore.listen(this.onTemplatePermissionStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        window.addEventListener('resize', this.onWindowResize);
        if (!this.state.templatePermissionStoreState.permissions[this.props.channelId]) {
            TemplatePermissionActions.getProjectTemplatePermissions(
                uuid.v4(),
                {
                    channelId: this.props.channelId,
                    projectId: this.props.projectId,
                }
            );
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
        this.unsubscribes.forEach(u => u());
    }

    onTemplateStoreChange(state) {
        this.setState({ templateStoreState: state });
    }

    onProjectStoreChange(state) {
        const newProjectStoreState = ProjectStore.getStateProject(this.props.projectId);
        if (state.initialized && !newProjectStoreState.project) {
            Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.AUTHORING);
            return;
        }

        this.setState({
            projectStoreState: newProjectStoreState
        });
    }

    onActivityStoreChange(state) {
        if (state.action.id === this.state.createActivityActionId && !state.action.error) {
            this.setState({ createActivityModalState: false }, () => {
                this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${state.action.newActID}/edit`);
            });

            return;
        }

        this.setState({ activityStoreState: state });
    }

    onTemplatePermissionStoreChange(state) {
        this.setState({ templatePermissionStoreState: state });
    }

    onWindowResize(event) {
        this.setState({ pageWidth: event.target.innerWidth });
    }

    createActivity(name) {
        const createActivityActionId = uuid.v4();
        const subtype = this.state.selectedSubtype;
        this.setState({ createActivityActionId: createActivityActionId }, () => {
            ActivityActions.createActivity(
                createActivityActionId,
                {
                    moduleId: this.state.selectedTemplate.module_id,
                    projectId: this.props.projectId,
                    title: name,
                    subtype,
                }
            );

        });
    }

    selectTemplate(tmpl) {
        let selectedSubtype = null;
        if (tmpl) {
            try {
                let create_info = JSON.parse(tmpl.create_info);
                let subtypes = create_info.subtypes;
                if (subtypes && (subtypes.length > 1)) {
                    selectedSubtype = subtypes[0].parameter;
                }
            }
            catch(e) {
                console.log("unable to parse template create_info",e);
            }
        }
        
        this.setState({ selectedTemplate: tmpl, selectedSubtype });
    }

    backHandler() {
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}`);
    }

    setCreateActivityModalState(showBool) {
        this.setState({ createActivityModalState: showBool });
    }

    onSelectSubtype=(e)=>{
        let selectedSubtype = e.target.value;
        this.setState({selectedSubtype});
    }

    render() {
        const templatePermissions = this.state.templatePermissionStoreState.permissions[this.props.channelId] || [];
        const availableTemplates = filter(this.state.templateStoreState.templates, userTemplate => {
            return !!templatePermissions.find(perm => perm.id === userTemplate.id );
        });
        let subtypeSelector = null;
        if (this.state.selectedTemplate) {
            let create_info = JSON.parse(this.state.selectedTemplate.create_info);
            let subtypes = create_info.subtypes;
            if (subtypes && (subtypes.length > 1)) {
                subtypeSelector = (
                    <div id="create-activity-type-select" className="margin-top-md" role="radiogroup">
                        {map(subtypes,(entry,i)=>{ 
                            let v = entry.parameter || "";
                            let id = `create-activity-type-select-${v}`;
                            return (
                                <ActivityTypeDiv className="create-activity-type-select">
                                    <input id={id}
                                        type="radio"
                                        value={v}
                                        checked={this.state.selectedSubtype === v}
                                        onChange={this.onSelectSubtype}
                                    />
                                    <label htmlFor={id}>
                                        {entry.title}
                                    </label>
                                </ActivityTypeDiv>
                            )
                        })}
                    </div>
                    /*
                    <label>
                        {'Activity Type:'}
                        <select value={this.state.selectedSubtype || ""} onChange={this.onSelectSubtype}>
                            {map(subtypes,(entry,i)=>{ 
                                return (
                                    <option key={i} value={entry.parameter || ""}>{entry.title}</option>
                                )
                            })}
                        </select>
                    </label>
                    */
                )
            }
        }

        return (
            <div className="create-activity-page">
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.channelId)}
                />
                {(!this.state.templateStoreState.initialized || !this.state.projectStoreState.initialized) ?
                    <div className="container main-container">
                        <LoadingMainContent />
                    </div>
                    :
                    <div className="container main-container">
                        <SubNav noGutters menuClasses="d-inline-block d-sm-none">
                            <BackButton backHandler={this.backHandler} />
                            <div className="view-info-container">
                                <div className="view-title">
                                    Activity Menu
                                </div>
                                <div className="view-description">
                                    List of Templates
                                </div>
                            </div>
                        </SubNav>

                        {this.state.hasError && !this.state.createActivityModalState ?
                            <Row noGutters>
                                <ErrorBox error={{ message: this.state.errorMessage }} />
                            </Row>
                            :
                            <Row noGutters className="main-content-nav">
                                <TemplateNav
                                    templates={availableTemplates}
                                    selectTemplate={this.selectTemplate}
                                    selectedTemplate={this.state.selectedTemplate}
                                    pageWidth={this.state.pageWidth}
                                    create={this.setCreateActivityModalState.bind(this, true)}
                                />
                                <div className="d-none d-sm-block col-sm-9 main-content">
                                    {this.state.selectedTemplate ?
                                        <SelectedTemplateContent
                                            template={this.state.selectedTemplate}
                                            create={this.setCreateActivityModalState.bind(this, true)}
                                        />
                                        :
                                        <div className="top">
                                            <div className="top-bg" />
                                            {/*<div className="fake-header" />*/}
                                            <div className="waiting-for-selection">
                                                <div className="text">
                                                    Select an Activity Template
                                                </div>
                                                <div className="icons">
                                                    {availableTemplates.map((tmpl) =>
                                                        <img key={tmpl.id} src={`${GlobalConfig.StaticUrl}/img/templates/${tmpl.icon}`} />
                                                    )}
                                                </div>
                                                <div className="text">
                                                    to get started.
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </Row>
                        }
                    </div>
                }
                {(this.state.createActivityModalState) &&
                    <SingleInputModal
                        show
                        action={this.state.activityStoreState.action}
                        childActionID={this.state.createActivityActionId}
                        headerText="Name Activity"
                        inputLabel="new name"
                        ariaLabel="new name"
                        buttonText="confirm"
                        closeHandler={this.setCreateActivityModalState.bind(this, false)}
                        submitHandler={this.createActivity}
                    >
                        {subtypeSelector}
                    </SingleInputModal>
                }
            </div>
        );
    }
}

CreateActivityView.propTypes = propTypes;
CreateActivityView.defaultProps = defaultProps;

const WrappedComponent = withRouter(CreateActivityView);

function WrappedComponentWithUpdatedPropNames(props) {
    return (
        <WrappedComponent
            {...props}
            projectId={props.match.params.projectID}
            channelId={props.match.params.channel}
        />
    );
}

WrappedComponentWithUpdatedPropNames.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channel: PropTypes.string.isRequired,
            projectID: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default WrappedComponentWithUpdatedPropNames;

const TemplateNavPropTypes = {
    selectTemplate: PropTypes.func.isRequired,
    selectedTemplate: PropTypes.object,
    templates: PropTypes.array,
    pageWidth: PropTypes.number.isRequired,
};

const TemplateNavDefaultProps = {
    selectedTemplate: null,
    templates: [],
};

class TemplateNav extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            queuedChange: null,
        };

        this.queueCollapseChange = this.queueCollapseChange.bind(this);
    }

    queueCollapseChange() {
        return;
        /*
        const _this = this;
        if (!!this.state.queuedChange) {
            return;
        }

        this.setState({
            queuedChange: window.setTimeout(() => {
                const templateClassName = getTemplateClassName(_this.props.selectedTemplate);
                $(`.collapse[data-tmpl!='${templateClassName}']`).hide(0, () => {
                        $(`.collapse[data-tmpl='${templateClassName}']`).show(0);
                });

                _this.setState({ queuedChange: null });
            }, 25)
        })
        */
    }

    render() {
        return (
            <div className="col-12 col-sm-3">
                <div className="template-list-container">
                    {this.props.templates.map((tmpl) => {
                        const selected = !!this.props.selectedTemplate && this.props.selectedTemplate.id === tmpl.id;

                        if (isXsScreen(this.props.pageWidth)) {
                            return (
                                <TemplateAccordionRow
                                    key={tmpl.id}
                                    template={tmpl}
                                    selectTemplate={this.props.selectTemplate}
                                    selected={selected}
                                    queueCollapseChange={this.queueCollapseChange}
                                    create={this.props.create}
                                />
                            );
                        }
                        else {
                            return (
                                <TemplateNavRow
                                    key={tmpl.id}
                                    template={tmpl}
                                    selectTemplate={this.props.selectTemplate}
                                    selected={selected}
                                    create={this.props.create}
                                />
                            );
                        }
                    })}
                </div>
            </div>
        );
    }
}

TemplateNav.propTypes = TemplateNavPropTypes;
TemplateNav.defaultProps = TemplateNavDefaultProps;

const TemplateAccordionRowPropTypes = {
    template: PropTypes.object.isRequired,
    selectTemplate: PropTypes.func.isRequired,
    queueCollapseChange: PropTypes.func.isRequired,
    create: PropTypes.func.isRequired,
    selected: PropTypes.bool,
};

const TemplateAccordionRowDefaultProps = {
    selected: false,
};

function TemplateAccordionRow(props) {
    return (
        <div className="template-list">
            <a href="#">
                <div
                    className={props.selected ? "template-header centered selected" : "template-header centered"}
                    onClick={props.selectTemplate.bind(null, props.template)}
                >
                    <div className="template-icon">
                        <img src={`${GlobalConfig.StaticUrl}/img/templates/${props.template.icon}`} />
                    </div>
                    <div className="template-label">
                        <div className="title">{props.template.name}</div>
                        <div className="short-desc">Build a conversation challenge</div>
                    </div>
                </div>
            </a>
            {props.selected &&
                <div data-tmpl={getTemplateClassName(props.template)}>
                    <div className="template-container">
                        <SelectedTemplateContent
                            template={props.template}
                            create={props.create}
                        />
                    </div>
                </div>
            }
        </div>
    );
}

TemplateAccordionRow.propTypes = TemplateAccordionRowPropTypes;
TemplateAccordionRow.defaultProps = TemplateAccordionRowDefaultProps;

const TemplateNavRowPropTypes = {
    template: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    selectTemplate: PropTypes.func.isRequired,
};
const TemplateNavRowDefaultProps = {
    selected: false,
};

function TemplateNavRow(props) {
    return (
        <div className="template-list">
            <a href="#">
                <div className={props.selected ? "template-header selected" : "template-header"} onClick={props.selectTemplate.bind(null, props.template)}>
                    <div className="template-icon">
                        <img src={`${GlobalConfig.StaticUrl}/img/templates/${props.template.icon}`} />
                    </div>
                    <div className="template-label">
                        <div className="title">{props.template.name}</div>
                        <div className="short-desc">{props.template.createInfo ? props.template.createInfo.shortDesc : ''}</div>
                    </div>
                </div>
            </a>
        </div>
    );
}

TemplateNavRow.propTypes = TemplateNavRowPropTypes;
TemplateNavRow.defaultProps = TemplateNavRowDefaultProps;

const SelectedTemplateContentPropTypes = {
    template: PropTypes.object.isRequired,
    create: PropTypes.func.isRequired,
};

const SelectedTemplateContentDefaultProps = {
};

function SelectedTemplateContent(props) {
    if (!props.template.createInfo) {
        return <ErrorBox error={{ message: 'No Template Data' }} />;
    }

    return (
        <div className="create-template-container">
            <div className="top">
                <div className="top-bg"></div>
                <div className="header">
                    <div className="d-none d-sm-block title">
                        {props.template.name}
                    </div>
                    <div className="create-activity-button">
                        <Button onClick={props.create}>create new activity</Button>
                    </div>
                </div>
                <div className="long-desc">
                    {props.template.createInfo.longDesc}
                </div>
                <div className="how-to">
                    <div className="steps-container">
                        {!!props.template.createInfo.howToPlaySteps && props.template.createInfo.howToPlaySteps.length > 0 &&
                            <div className="how-to-steps">
                                <div className="title">How to Play</div>
                                {props.template.createInfo.howToPlaySteps.map((step) =>
                                    <div className="step-row" key={step.step}>
                                        <div className="step-num">Step {step.step}.</div>
                                        <div className="step-val">{step.text}</div>
                                    </div>
                                )}
                            </div>
                        }
                        {!!props.template.createInfo.demoLink &&
                            <div className="demo">
                                <a href={props.template.createInfo.demoLink} target="_blank" rel="noopener noreferrer">
                                    <img src={`${GlobalConfig.StaticUrl}/img/Play.svg`} style={{width:'24px'}} alt="Play" />
                                    Play {props.template.name} demo
                                </a>
                            </div>
                        }
                    </div>
                    { !!props.template.createInfo.videoLink &&
                        <div className="video">
                            <div className="aspect-ratio">
                                <iframe
                                    id="ytplayer"
                                    type="text/html"
                                    src={props.template.createInfo.videoLink}
                                    frameBorder="0"
                                    allowFullScreen="1"
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
            {isArray(props.template.createInfo.objectives) && props.template.createInfo.objectives.length > 0 &&
                <div className="objectives">
                    {props.template.createInfo.objectives.map((objective, index) =>
                        <div className="objective" key={index}>
                            <div className="icon">
                                <img src={`${GlobalConfig.StaticUrl}/img/SmallCheck.svg`} style={{width:'24px'}} alt="Check mark" />
                            </div>
                            <div className="text-area">
                                <div className="title">
                                    {objective.title}
                                </div>
                                <div className="subtitle">
                                    {objective.subtitle}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            }
            {isArray(props.template.createInfo.authoringSteps) && props.template.createInfo.authoringSteps.length > 0 &&
                <div>
                    <div className="heading">Authoring</div>
                    <div className="entries">
                        {props.template.createInfo.authoringSteps.map((step, index) =>
                            <div className="entry-area" key={index}>
                                <div className="icon">
                                    <img
                                        src={`${GlobalConfig.StaticUrl}/img/authoring_steps/${step.image}`}
                                        alt="Step"
                                        role="presentation"
                                        aria-hidden
                                    />
                                </div>
                                <div className="title">{step.title}</div>
                            </div>
                        )}
                    </div>
                </div>
            }
            {isArray(props.template.createInfo.assetTypes) && props.template.createInfo.assetTypes.length > 0 &&
                <div>
                    <div className="heading">Assets</div>
                    <div className="entries">
                        {props.template.createInfo.assetTypes.map((type, index) =>
                            <div className="entry-area" key={index}>
                                <div className="icon">
                                    <img
                                        src={`${GlobalConfig.StaticUrl}/img/asset_types/${type.image}`}
                                        alt="Asset type"
                                        role="presentation"
                                        aria-hidden
                                    />
                                </div>
                                <div className="title">{type.title}</div>
                            </div>
                        )}
                    </div>
                </div>
            }
        </div>
    );
}

SelectedTemplateContent.propTypes = SelectedTemplateContentPropTypes;
SelectedTemplateContent.defaultProps = SelectedTemplateContentDefaultProps;